import { render, staticRenderFns } from "./LinkedInPlatformIcon.vue?vue&type=template&id=eef6c746&scoped=true"
import script from "./LinkedInPlatformIcon.vue?vue&type=script&lang=js"
export * from "./LinkedInPlatformIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef6c746",
  null
  
)

export default component.exports